import * as React from "react";

interface Props {
    value: string;
    name: string;
    suggestions: Suggestion[];
    onKeyDown?: (e: any) => void;
    onClick?: (e: any) => void;
    onChange?: (e: any) => void;
}
interface State {
    activeSuggestion: number;
    filteredSuggestions: Suggestion[];
    showSuggestions: boolean;
    userInput: string;
}
interface Suggestion {
    id: number; // Replace with the actual type of id
    name: string;
}
export default class AutoCompleteVendor extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            // The active selection's index
            activeSuggestion: 0,
            // The suggestions that match the user's input
            filteredSuggestions: [],
            // Whether or not the suggestion list is shown
            showSuggestions: false,
            // What the user has entered
            userInput: "",
        };
    }

    onChange = (e: any) => {
        const { suggestions } = this.props;
        const userInput = e.currentTarget.value;

        // Filter our suggestions that don't contain the user's input
        const filteredSuggestions = suggestions.filter(
            (suggestion) =>
                suggestion.name.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        this.setState({
            activeSuggestion: 0,
            filteredSuggestions: filteredSuggestions,
            showSuggestions: true,
            userInput: e.currentTarget.value,
        });
        this.props.onChange && this.props.onChange(e);
    };

    onClick = (e: any) => {
        this.setState({
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: false,
            userInput: e.currentTarget.innerText,
        });
        this.props.onClick && this.props.onClick(e);
    };

    onKeyDown = (e: any) => {
        const { activeSuggestion, filteredSuggestions } = this.state;
        //console.log("e.keyCode: " + e.keyCode);
        // User pressed the enter key
        if (e.keyCode === 13) {
            this.setState({
                activeSuggestion: 0,
                showSuggestions: false,
                userInput: filteredSuggestions[activeSuggestion].name,
            });
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion - 1 });
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === filteredSuggestions.length) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion + 1 });
        }
        this.props.onKeyDown && this.props.onKeyDown(e);
    };

    render() {
        const {
            onChange,
            onClick,
            onKeyDown,
            state: {
                activeSuggestion,
                filteredSuggestions,
                showSuggestions,
                userInput,
            },
        } = this;

        let suggestionsListComponent;

        if (showSuggestions && userInput) {
            if (filteredSuggestions.length) {
                suggestionsListComponent = (
                    <ul className="suggestions">
                        {filteredSuggestions.map((suggestion, index) => {
                            let className;

                            // Flag the active suggestion with a class
                            if (index === activeSuggestion) {
                                className = "suggestion-active";
                            }
                            return (
                                <li className={className} key={suggestion.id} onClick={onClick}>
                                    {suggestion.name}
                                </li>
                            );
                        })}
                    </ul>
                );
            } else {
                suggestionsListComponent = (
                    <div className="no-suggestions">
                        <em>No suggestions</em>
                    </div>
                );
            }
        }

        return (
            <React.Fragment>
                <input
                    type="text"
                    style={{ width: "100%" }}
                    role="presentation"
                    className="form-control"
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    value={this.props.value ? this.props.value : userInput}
                    name={this.props.name}
                    required
                />
                {suggestionsListComponent}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/AutoCompleteVendor.tsx